import { useQuery } from '@tanstack/react-query';
import { Etablissement } from '@teetsh/app/src/types/etablissement';
import { searchEtablissements } from './searchEtablissements';

export const SEARCH_ETABLISSEMENTS_KEY = 'search-etablissements';

export interface SearchEtablissementsParams {
  query: string;
  country: string;
  state?: string;
}

export function useSearchEtablissements({
  query,
  country,
  state,
}: SearchEtablissementsParams) {
  return useQuery<Etablissement[]>({
    queryKey: [SEARCH_ETABLISSEMENTS_KEY, country, state, query],
    queryFn: () => searchEtablissements({ query, country, state }),
    enabled: !!query,
    refetchOnWindowFocus: false,
  });
}
